import {
  BANK_ALL,
  BANK_GET,
  BANK_POST,
  BANK_PUT,
  BANK_DEL,
  BANK_LOADING,
  BANK_ERROR,
} from '../../actions/types';

const initialState = {
  bank: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case BANK_LOADING:
      return { isLoading: true, isCompleted: true };
    case BANK_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case BANK_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case BANK_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case BANK_POST:
      return { isLoading: false, isCompleted: true };
    case BANK_PUT:
      return { isLoading: false, isCompleted: true };
    case BANK_DEL:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}